module.exports = __webpack_public_path__ + "static/media/chevron-up-black.6a65dd7c.svg";